module.exports = [
	{
		"start": 0.16,
		"text": "If I lose DACA, I’m not just going to lose a paper. I’m going to lose my job,"
	},
	{
		"start": 5.92,
		"text": "I’m going to lose all my dreams, I’m going to lose everything."
	},
	{
		"start": 10.26,
		"text": "Our house over there in Veracruz, it was made of palm leaves. We didn't even have electricity."
	},
	{
		"start": 17.91,
		"text": "So we were looking or seeking for a better life. I still remember how I crossed the border, it's something that I will never forget."
	},
	{
		"start": 26.04,
		"text": "I was 13 years old. They sent us to a desert."
	},
	{
		"start": 30.119,
		"text": "We stayed there for, I would say, two to three hours, and then that's when the vans picked up all of us, and we were driving for I don't know how many hours."
	},
	{
		"start": 40.03,
		"text": "I was just crying. I was like, \"When I'm going to be able to get home, to get to see my parents?\""
	},
	{
		"start": 46.72,
		"text": "I look around by the window and I'm like, \"Oh, finally I'm in the United States, you know?\""
	},
	{
		"start": 53.41,
		"text": "Before I had DACA, I used to work in a restaurant washing dishes. I remember I would start working like early morning, 10 a.m. up to midnight."
	},
	{
		"start": 63.769,
		"text": "Whenever I got my paycheck I was like, \"No, this is not right.\" It was no overtime pay."
	},
	{
		"start": 71.44,
		"text": "Whenever I got DACA and I saw my picture, that it said this is a permit to work, I felt happy"
	},
	{
		"start": 78,
		"text": "because I felt that nobody could tell me \"No.\" I was going to be able to apply to any job that I wanted."
	},
	{
		"start": 84.72,
		"text": "I was able to get an apartment for rent on my own name. I was able to get a car."
	},
	{
		"start": 93.3,
		"text": "Right now I'm working at Walmart as a department manager."
	},
	{
		"start": 97.6,
		"text": "Now that I have this job and I'm getting paid a little bit more, I was thinking to go back to school. I love kids, so I would like to be a teacher."
	}
];


//////////////////
// WEBPACK FOOTER
// ../assets/transcripts/neiva.json
// module id = 11
// module chunks = 0